/** URL publique Cal.com (build-time CRA). */
export const CAL_BOOKING_URL =
  process.env.REACT_APP_CAL_BOOKING_URL ||
  'https://cal.com/matthieu-neveux-leagora/30min';
